import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import logo from '../assets/logo.webp';
import { Link, useLocation } from 'react-router-dom';


export default function Contact() {


    return (
        <>
            <Helmet>
                <title>Contatti - Gate 51</title>
                <meta name="description" content="" />
            </Helmet>

            <Container fluid className='py-5 ps-0 pe-0' style={{ minHeight: '100vh' }}>
                <Container fluid='lg' className='text-white text-center'>
                    <Row>
                        <Col sm={12} md={8} className='mb-3'>
                            <Link to="/">
                                <Image src={logo} width={200} className='mb-5' />
                            </Link>
                            <h1>Sei curioso di saperne di più?</h1>
                            <p className='lead' style={{ maxWidth: 500, margin: 'auto' }}>
                                Veniteci a trovare a Conegliano o contattateci tramite Whatsapp
                                per chiederci qualsiasi tipo di informazione.
                                
                                <a href='https://wa.me/3755035466' target="_blank">
                                    <Button variant='success' size='lg' className='w-100 mt-3'>Whatsapp</Button>
                                </a>
                                <br/><br/>

                                <i>Info</i>: <b><a className="link-light" href="mailto:crossfitgate51@gmail.com">crossfitgate51@gmail.com</a></b><br />
                                <i>Tel</i>: <b><a className="link-light" href="tel:3755035466">3755035466</a></b><br/>
                                <i>Indirizzo:</i> Viale venezia, 51 – 31020 San vendemiano (TV)
                                <br/><br/>
                                
                                <br/><br/>
                                <span className='small'>
                                    Per info e segreteria la palestra sarà aperta dal lunedì al sabato dalle 9 alle 21.
                                    In caso di chiusura o urgenze contattare al numero 3755035466
                                </span>
                            </p>
                        </Col>
                        <Col sm={12} md={4} className='mb-3'>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2777.299879116684!2d12.317685576863235!3d45.88531517108404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477915f84f652023%3A0x9f092182d0e32976!2sCrossFit%20Gate51!5e0!3m2!1sit!2sit!4v1725441421639!5m2!1sit!2sit" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </Col>
                    </Row>
                    <div className='text-center mt-5'>
                        <Link to="/">
                            <Button variant='outline-secondary' size='lg'>Torna alla home</Button>
                        </Link>
                    </div>
                </Container>
            </Container>
        </>
    );
};